import { render, staticRenderFns } from "./TableElementsPerPage.vue?vue&type=template&id=a7c53fb8"
import script from "./TableElementsPerPage.vue?vue&type=script&setup=true&lang=js"
export * from "./TableElementsPerPage.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports